import styled, { css } from 'styled-components';
import { Col, Container, Row } from 'reactstrap';

const WHITE = '#ffffff';

export const Wrapper = styled.div`
  background: #f7f8f9;
  height: 100vh;
  min-height: 800px;
  padding: 0;
`;

export const StyledHeaderWrapper = styled(Row)`
  --bs-gutter-x: 0;
  margin: 0;
  height: 64px;
  background: ${WHITE};
  justify-content: center;
  align-items: center;
`;

const headerLeftCountdownTimerCSS = css`
  display: none;
`;

export const StyledHeaderLeft = styled.div`
  width: 50%;
  display: flex;
  justify-content: left;
  ${(props) => (!props.$hasCountdownTimer ? headerLeftCountdownTimerCSS : '')};
`;

const headerCountdownTimerCSS = css`
  width: 50%;
  justify-content: left;
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  ${(props) => (props.$hasCountdownTimer ? headerCountdownTimerCSS : '')};
`;

export const StyledCountdownTimerWrapper = styled.div`
  margin-left: 40px;
`;

export const StyledStreamButtonWrapper = styled.div`
  margin-right: 13px;
`;

export const StyledNotificationButtonWrapper = styled.div``;

export const StyledSceneWrapper = styled.div`
  padding: 0;
`;

export const SceneRendererWrapper = styled.div`
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ScaledSceneRendererWrapper = styled.div`
  overflow: hidden;
`;

export const StyledSceneLayoutWrapper = styled(Container)`
  padding: 0;
  width: ${({ stageWidth }) => stageWidth}px;
  max-width: ${({ stageWidth }) => stageWidth}px;
`;

export const StyledMediaSelectWrapper = styled.div`
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  justify-content: flex-start;
  order: 1;

  @media only screen and (max-width: 839px) {
    order: 3;
    grid-column: 1 / span 3;
    justify-content: center;
  }
`;

export const StyledSceneLayoutChooserWrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-self: center;
  order: 2;

  @media only screen and (max-width: 839px) {
    order: 1;
    justify-self: flex-start;
  }

  @media only screen and (max-width: 635px) {
    grid-column: 1 / span 3;
    justify-self: center;
  }
`;

export const StyledPresentationControlWrapper = styled.div`
  padding: 10px;
  display: flex;
  justify-self: center;
  order: 2;

  @media only screen and (max-width: 839px) {
    order: 1;
    justify-self: flex-start;
  }

  @media only screen and (max-width: 635px) {
    grid-column: 1 / span 3;
    justify-self: center;
  }
`;

export const StyledNameTagsToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  order: 3;
  margin-left: auto;

  @media only screen and (max-width: 839px) {
    order: 2;
    grid-column-start: 2;
    justify-content: flex-end;
  }

  @media only screen and (max-width: 635px) {
    grid-column: 1 / span 3;
    margin-left: 0;
    justify-content: center;
  }
`;

export const SceneLayoutWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr repeat(1, auto) 1fr;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;

  @media only screen and (max-width: 839px) {
    grid-template-columns: 2fr 1fr auto;
  }

  @media only screen and (max-width: 635px) {
    grid-template-columns: auto;
  }
`;

export const SourceListWrapper = styled(Col)`
  padding-left: 15px;
  padding-right: 15px;
`;

export const SourceListSticky = styled.section`
  width: 100vw;
  min-height: 205px;
  bottom: 0;
  background: #f7f8f9;
`;

export const StyledStage = styled.section``;

export const StyledSourceListWrapper = styled(Container)`
  padding: 0;
`;

export const StyledStageLabelWrapper = styled.div`
  width: ${({ stageWidth }) => stageWidth}px;
`;

export const StyledStageLabel = styled.label`
  display: flex;
  color: #33373d;
  font-size: 16px;
  font-weight: 600;
  margin-top: 8px;
  line-height: 24px;
  font-style: normal;
  margin-bottom: 8px;
  align-items: center;
`;

export const StyledFooterWrapper = styled(Row)``;

export const StyledFooter = styled.div``;

export const StyledAlertNotificationWrapper = styled.section``;

export const StyledMediaPlaybackController = styled.div`
  width: ${({ stageWidth }) => stageWidth}px;
`;
export const VideoNotificationAlertWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
